/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './campaign-generate.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/front/front-campaigns/campaign-generate/campaign-generate.component';
import * as i3 from '../../../../../app/front/front.service';
import * as i4 from '../../../../../app/services/campaign.service';
import * as i5 from '../../../../../app/services/element.service';
import * as i6 from '../../../../../app/services/template.service';
const styles_CampaignGenerateComponent:any[] = [i0.styles];
export const RenderType_CampaignGenerateComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CampaignGenerateComponent,data:{}});
export function View_CampaignGenerateComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'iframe',[['frameBorder',
      '0'],['id','template_preview']],(null as any),(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(null as any));
}
export function View_CampaignGenerateComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-campaign-generate',
      ([] as any[]),(null as any),(null as any),(null as any),View_CampaignGenerateComponent_0,
      RenderType_CampaignGenerateComponent)),i1.ɵdid(1,245760,(null as any),0,i2.CampaignGenerateComponent,
      [i3.FrontService,i4.CampaignService,i5.ElementService,i6.TemplateService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CampaignGenerateComponentNgFactory:i1.ComponentFactory<i2.CampaignGenerateComponent> = i1.ɵccf('app-campaign-generate',
    i2.CampaignGenerateComponent,View_CampaignGenerateComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9mcm9udC1jYW1wYWlnbnMvY2FtcGFpZ24tZ2VuZXJhdGUvY2FtcGFpZ24tZ2VuZXJhdGUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9mcm9udC1jYW1wYWlnbnMvY2FtcGFpZ24tZ2VuZXJhdGUvY2FtcGFpZ24tZ2VuZXJhdGUuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2Zyb250L2Zyb250LWNhbXBhaWducy9jYW1wYWlnbi1nZW5lcmF0ZS9jYW1wYWlnbi1nZW5lcmF0ZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9mcm9udC1jYW1wYWlnbnMvY2FtcGFpZ24tZ2VuZXJhdGUvY2FtcGFpZ24tZ2VuZXJhdGUuY29tcG9uZW50LnRzLkNhbXBhaWduR2VuZXJhdGVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aWZyYW1lIGlkPVwidGVtcGxhdGVfcHJldmlld1wiIGZyYW1lQm9yZGVyPVwiMFwiPjwvaWZyYW1lPiIsIjxhcHAtY2FtcGFpZ24tZ2VuZXJhdGU+PC9hcHAtY2FtcGFpZ24tZ2VuZXJhdGU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUE7OztvQkNBQTtNQUFBOzBDQUFBLFVBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/front-campaigns/campaign-generate/campaign-generate.component.ngfactory.ts